import {Routes, Route, Link} from 'react-router-dom'; 
import { useState } from 'react';
import { CgMenuMotion } from "react-icons/cg"; 
import { Home } from './Home';
import { Contact } from './Contact';
import { Calculation } from './Calculation';
export const Header = () => {

  const [toogle, setToogle] = useState(true);

  return (
    <>
    <header>
  
<nav className="bg-white border-gray-200 dark:bg-gray-900">
  <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
    <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
        <img src="https://flowbite.com/docs/images/logo.svg" className="h-8" alt="Logo" />
        <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">FlowRun</span>
    </Link>
    <button onClick={()=> setToogle(!toogle)} data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-default" aria-expanded="false">
        <span className="sr-only">Open main menu</span>
        <CgMenuMotion size="30" />
    </button>
    <div className={` ${toogle ? "hidden" : null} w-full md:block md:w-auto`}   id="navbar-default">
      <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
        
        
        <li>
          <Link to="/" onClick={()=> setToogle(!toogle)} className="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent" >Home</Link>
        </li>

        <li>
          <Link to="/calculation" onClick={()=> setToogle(!toogle)} className="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent" >Race Pace Calculator</Link>
        </li>

        
        <li>
          <Link to="/contact" onClick={()=> setToogle(!toogle)}  className="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Race Time Prediction</Link>
        </li>
      </ul>
    </div>
  </div>
</nav>

    </header>

    <main className="w-10/12 mx-auto p-4">
     <Routes>
        <Route path="/" element={ <Home /> } />
        <Route path="/calculation" element={ <Calculation /> } />
        <Route path="/contact" element={ <Contact /> } />
      </Routes>
    </main>

      </>
  )
}
